import { render } from "./CreateFeedItem.vue?vue&type=template&id=d891b64c"
import script from "./CreateFeedItem.vue?vue&type=script&lang=js"
export * from "./CreateFeedItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__